export const UserStatus = {
  ALL: {
    id: null,
    value: "All",
  },
  ACTIVE: {
    id: 1,
    value: "Active",
  },
  BLOCKED: {
    id: 2,
    value: "Blocked",
  },
  INVITED: {
    id: 3,
    value: "Invited",
  },
  LOCKED: {
    id: 4,
    value: "Locked",
  },
};
